import { useMemo } from "react";
import DataSource from "devextreme/data/data_source";

/**
 * Hook to group items by user and by group.
 * @param {Array} itemsList - List of items
 * @param {Array} userList - List of users
 * @param {Array} [groupList] - List of groups (to display the group display name)
 * @returns {DataSource} DataSource configured for grouping
 */
export const useGroupedItems = (itemsList, userList, groupList) => {
  return useMemo(() => {
    if (
      !itemsList ||
      !userList ||
      itemsList.length === 0 ||
      userList.length === 0
    ) {
      return new DataSource({
        store: {
          data: [],
          type: "array",
          key: "id",
        },
      });
    }

    // Enrich the datasets with the display name of the user and (if present) the group
    const enrichedItems = itemsList.map((item) => {
      const user = userList.find((u) => u.id === item.userId);
      const group =
        groupList && item.groupId
          ? groupList.find((g) => g.id === item.groupId)
          : null;

      const userDisplayName = user ? user.displayName : "Unknown user";
      const groupDisplayName = group ? group.displayName : "Unknown group";

      return {
        ...item,
        userDisplayName,
        groupDisplayName,
        groupedLabel: groupList
          ? `${groupDisplayName} - ${userDisplayName}`
          : userDisplayName,
      };
    });

    const groupSelector = groupList ? "groupedLabel" : "userDisplayName";

    return new DataSource({
      store: {
        data: enrichedItems,
        type: "array",
        key: "id",
      },
      group: groupSelector,
    });
  }, [itemsList, userList, groupList]);
};
